<template>
  <div class="detail-cards">
    <div class="detail-cards__inner">
      <div class="detail-cards__content">
        <div class="detail-cards__section">
          <AccordBlock>
            <template slot="header">
              <div v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['fbm_OrderDetails'])"></div>
                {{$t('fbm_OrderDetails.localization_value.value')}}
              </div>
            </template>
            <template slot="body">

<!--              <SendFromBlock-->
<!--                  :FBM="FBM"-->
<!--                  :isAdminEdit="false"-->
<!--              />-->

              <StepOne
                  :FBM="FBM"
                  :personal="FBM.data.Personal"
                  :deliveryPayPal="FBM.data.DeliveryPayPal"
                  :deliveryEtsy="FBM.data.DeliveryEtsy"
                  :isEdit="true"
              />

              <StepTwo
                  :FBM="FBM"
                  :proformProducts="FBM.data.ProformProducts"
                  :products="FBM.data.Products"
                  :productsForCellArray="FBM.data.productsForCellArray"
                  :user="FBM.data.User"
                  @changeCategory="({val, nameVal, item}) => changeCategoryProform({val, nameVal, item}, FBM.getTrsnAddressCountry(), true)"
                  @changeProformSelectItem="item => changeProformSelectItem(item, FBM.getTrsnAddressCountry())"
                  @addProformProduct="$emit('addProformProduct')"
                  @removeProformProduct="i => $emit('removeProformProduct', i)"
              />
            </template>
          </AccordBlock>

        </div>
        <div class="detail-cards__section">
          <AccordBlock>
            <template slot="header">
              <div v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['fbm_ShippingPackage'])"></div>
                {{$t('fbm_ShippingPackage.localization_value.value')}}
              </div>
            </template>
            <template slot="body">
              <StepThree
                  :FBM="FBM"
                  :user="FBM.data.User"
                  :etsyCountry="FBM.data.DeliveryEtsy.delivery.country"
                  :paypalCountry="FBM.data.DeliveryPayPal.delivery.country"
              />

              <PriceBlock
                  v-if="!isLabel"
                  ref="fbmExpertUserPriceBlock"
                  :FBM="FBM"
                  :loadingPrepayPrice="loadingPrepayPrice"
                  :prepayError="prepayError"
                  :dutyValue="true"
              />
            </template>
          </AccordBlock>
        </div>
        <div class="detail-cards__section detail-cards__section--btn">
          <div class="detail-cards__section-col">
            <router-link :to="$store.getters.GET_PATHS.easyOrders"
                         class="site-link site-link--alt"
                         v-if="isEasyType"
            >
              {{ $t('common_cancel.localization_value.value') }}
            </router-link>
            <router-link v-else :to="$store.getters.GET_PATHS.ordersFBM">
              <span class="site-link site-link--alt brown">
              {{$t('common_cancel.localization_value.value')}}
              </span>
            </router-link>
          </div>
          <div class="detail-cards__section-col">
            <MainButton
                class="order-create__footer-btn-i secondary"
                :value="$t('common_SaveInDrafts.localization_value.value')"
                :tooltip="true"
                v-bind:class="{'disabled-btn' : $store.getters.getOrdersFBMBtn || loadingPrepayPrice}"
                @click.native="trySaveFBMAdvancedUser({draft: true})"
            >
              <template slot="tooltip">
                <p>
                  <b>{{$t('common_drafts.localization_value.value')}}</b>
                </p>
                <p>
                  {{$t('common_savingInDrafts.localization_value.value')}}
                </p>
              </template>
            </MainButton>

            <!--            !isLabel &&-->
            <MainButton
                v-if=" (isLabel || isUserPrepayment || isConsolidation) && !gotPrepayment"
                class="order-create__footer-btn-i"
                :value="$t('fbm_calculatePrepay.localization_value.value')"
                @click.native="getPrepay()"
                v-bind:class="{'disabled-btn' : $store.getters.getOrdersFBMBtn || $store.getters.getOrdersFBABtn || loadingPrepayPrice}"
            />

            <MainButton
                v-else-if="((isLabel) || isWarehouse || isConsolidation) && !prepayError"
                class="order-create__footer-btn-i"
                :value="$t('common_create.localization_value.value')"
                @click.native="trySaveFBMAdvancedUser({draft: false, createLabel: isConsolidation && canCreateLabel, adminManage: isAdmin})"
                v-bind:class="{'disabled-btn' : $store.getters.getOrdersFBABtn || $store.getters.getOrdersFBMBtn || $store.getters.getEasyOrdersBtn || loadingPrepayPrice}"
            />

            <MainButton
                v-if="!prepayError && (isLabel && canCreateLabel) && gotPrepayment"
                class="order-create__footer-btn-i"
                :value="$t('common_buyLabel.localization_value.value')"
                @click.native="$emit('prepareSaveFBM', {draft: false, createLabel: true})"
                v-bind:class="{'disabled-btn' : $store.getters.getOrdersFBMBtn || $store.getters.getOrdersFBABtn || $store.getters.getOrdersFBMCompanyLoading}"
            />
          </div>
        </div>
      </div>
      <div class="detail-cards__aside">
        <div class="detail-cards__aside-inner">
<!--          <OrderCard-->
<!--              :FBM="FBM"-->
<!--              :user="FBM.data.User"-->
<!--              :personal="FBM.data.Personal"-->
<!--              :deliveryFBM="FBM.data.DeliveryPayPal"-->
<!--              @reload="reload"-->
<!--          />-->

          <div class="detail-page__left"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate([
              'common_NewOrder',
            ])"></div>
            <CardLeftBlock
                :backgroundImage="'consolidation'"
                :name="''"
                :value="''"
            >
              <template slot="body">
                <div class="d-flex mb-3">
                  <div class="user-card__img">
                    <div class="user-card__img-i">
                      <img v-if="FBM.data.User.userAvatar.id"
                           :src="`data:${FBM.data.User.userAvatar.mimeType};base64,${FBM.data.User.userAvatar.base64}`" alt="img">
                      <img v-else style="background: #ce9e64" src="/img/profile-group/profile-photo-default.svg" alt="img">
                    </div>
                  </div>
                  <div class="ml-2">
                    <div class="user-card__head-name" v-if="Object.keys(FBM.data.User.user).length > 0">
                      <ValueHelper
                          v-if="FBM.data.User.user && FBM.data.User.user.contacts"
                          :value="FBM.data.User.user"
                          :deep="'contacts.0.user_full_name'"
                      />
                      <ValueHelper
                          v-else
                          :value="FBM.data.User.user"
                          :deep="'user_personal_contact.user_full_name'"
                      />
                    </div>
                    <div class="amount-row light">
                      Balance:
                      <span class="color-red important font-weight-bold m-0">$ {{FBM.data.User.user.balance}} </span>
                    </div>
                  </div>
                </div>

                <h2 class="mt-0">{{$t('common_NewOrder.localization_value.value')}}</h2>
                <div class="card-detail-left__date">
                  {{ new Date() | moment("DD MMM, YYYY") }}
                </div>
              </template>
            </CardLeftBlock>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MainButton from "../../../../../UI/buttons/MainButton/MainButton";
  // import LinkButton from "../../../../../UI/buttons/LinkButton/LinkButton";
  import StepTwo from "../../components/FBMAdvancedUserBlocks/StepTwo/StepTwo";
  import StepThree from "../../components/FBMAdvancedUserBlocks/StepThree/StepThree";
  import {FBM_ORDER_TYPES} from "../../../../../../staticData/staticVariables";
  import {proformMixins} from "../../../../../../mixins/proformMixins/proformMixins";
  import {tabsMixins} from "../../../../../../mixins/creationPageMixins/tabsMixins";
  import {FBMMixins} from "../../../../../../mixins/FBMMixins/FBMMixins";
  // import TitleHorizontal from "@/components/coreComponents/TitleHorizontal/TitleHorizontal";
  // import DotsShadowPreloader from "@/components/coreComponents/preloaders/DotsShadowPreloader/DotsShadowPreloader";
  // import LabelPrice from "@/components/coreComponents/LabelPrice/LabelPrice";
  import PriceBlock from "@/components/modules/OrdersFBMModule/components/components/chunks/PriceBlock/PriceBlock";
  // import OrderCard from "../../components/FBMAdvancedUserBlocks/OrderCard/OrderCard";
  import AccordBlock from "../../../../../coreComponents/AccordBlock/AccordBlock";
  // import SendFromBlock
  //   from "@/components/modules/OrdersFBMModule/components/components/chunks/SendFromBlock/SendFromBlock";
  import StepOne from "@/components/modules/OrdersFBMModule/components/components/FBMUserBlocks/StepOne/StepOne.vue";
  import CardLeftBlock from "@/components/coreComponents/CardLeftBlock/CardLeftBlock.vue";
  import ValueHelper from "@/components/coreComponents/ValueHelper/ValueHelper.vue";

  export default {
    name: "OrdersFBMAdvancedCreationPage",
    components: {
      ValueHelper,
      CardLeftBlock,
      StepOne,
      // SendFromBlock,
      AccordBlock,
      PriceBlock,
      // LabelPrice,
      // DotsShadowPreloader,
      // TitleHorizontal,
      MainButton,
      StepTwo,
      StepThree,
      // OrderCard
    },

    mixins: [proformMixins, tabsMixins, FBMMixins],

    props: {
      FBM: Object,
      advancedUI: Boolean,
    },

    computed: {
      FBMObjectString() {
        let proformJson = ''
        this.FBM.data.ProformProducts.forEach(p => {
          Object.keys(p.product.proformData.proformTypes).map(item => {
            if(p.product.proformData.proformTypes[item]?.typeValue) {
              proformJson += JSON.stringify(p.product.proformData.proformTypes[item].typeValue)
            }
          })
        })

        return JSON.stringify(this.FBM.data.Personal) + JSON.stringify(this.FBM.data.PersonalEtsy) + JSON.stringify(this.FBM.data.DeliveryPayPal) +
            JSON.stringify(this.FBM.data.DeliveryEtsy) + proformJson + JSON.stringify(this.FBM.data.productsForCellArray) +
            JSON.stringify(this.FBM.data.Dimensions) + JSON.stringify(this.FBM.data.insuranceAmount) + JSON.stringify(this.FBM.data.insuranceCost) +
            JSON.stringify(this.FBM.data.shippingPartner) + JSON.stringify(this.FBM.data.packagingType) + JSON.stringify(this.FBM.data.giftPackagingType) +
            JSON.stringify(this.FBM.data.giftPaper) + JSON.stringify(this.FBM.data.isInsurance) + JSON.stringify(this.FBM.data.signFromRecipient) +
            JSON.stringify(this.FBM.data.visibleVatNumber) + JSON.stringify(this.FBM.data.popularMethodsType) + JSON.stringify(this.FBM.data.popularMethodSelected)
      },

    },

    watch: {
      FBMObjectString() {
        if (this.gotPrepayment) {
          this.gotPrepayment = false
        }
      },

      calculatePrice() {
        if(this.FBM.data.popularMethodsType) {
          this.getPopularMethods()
        } else {
          this.getShippingPrices()
        }
      },

      calculateProductPrice() {
        if(this.FBM.data.popularMethodsType) {
          this.getPopularMethods()
        } else {
          this.getShippingPrices()
        }
      },
    },

    data() {
      return {

        FBM_ORDER_TYPES: FBM_ORDER_TYPES,

        progressStepsSetting: [
          this.$t('fbm_CustomerInformation.localization_value.value'),
          this.$t('fbm_OrderDetails.localization_value.value'),
          this.$t('fbm_ShippingPackage.localization_value.value'),
          this.$t('fbm_Confirmation.localization_value.value'),
        ],

        activeStep: 1,

        isModalTransactionInfo: false,

        loadingPrepayPrice: false,
        prepayError: false,
        canCreateLabel: false,
        gotPrepayment: false,

        keyReload: -1,
      }
    },

    methods: {

      showTransactionInfo() {
        this.isModalTransactionInfo = true
      },

      closeTransactionInfo() {
        this.isModalTransactionInfo = false
      },

      reload() {
        this.keyReload = Math.random()
      },

      trySaveFBMAdvancedUser(args) {
        if (!this.expertUserValidate(false, true)) return

        if(this._.has(this.FBM.getShippingAPIPrice(), 'can_create_label')) {
          this.canCreateLabel = this.FBM.getShippingAPIPrice()?.can_create_label
          if(!args.draft && this.isConsolidation) {
            args.createLabel = this.canCreateLabel
          }
        }

        this.$emit('prepareSaveFBM', args)
      },

      async getPrepay() {
        if(this.FBM.data.popularMethodsType) {
          await this.getPopularMethods(false)
        }

        if (!this.expertUserValidate(true)) return

        this.gotPrepayment = true
      },
    },


  }
</script>


<style scoped lang="scss">
@import "../../../../../../scss/mixins/mixins";

.detail-cards__section--btn {
  width: calc(100% - 330px - 30px);

  @include for-1600{
    left: 103px;
    width: calc(100% - 130px);
  }

  @include for-1200{
    left: 103px;
    width: calc(100% - 103px - 30px);
  }

  @include for-1120{
    position: relative;
    left: auto;
    width: 100%;
  }

}

.detail-cards__aside {
  order: -1;
  @media (max-width: 1220px) {
    order: 1;
  }
}

.card-detail-left {
  @media (min-width: 1220px) {
    min-height: calc(100vh - 120px);
  }
}

@media (max-width: 767px) {
  .user-card__img {
    width: auto;
  }
}

@media (max-width: 550px) {
  .detail-cards__aside-inner ::v-deep .card-detail-left.easy-order .card-detail-left__bg--consolidation {
    display: none;
  }
}
</style>
